<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div class="data">
    <div class="mobileBox">
      <bannerSwipe
        :list="bannerList"
        :site-id="siteid"
      />
      <hometab
        :list="tabList"
        :cataloglist="catalogList"
        :site-id="siteid"
        @catalogDetail="catalogDetail"
      />
      <lebals
        class="post"
        :showqq="showqq"
        :showdz="showdz"
      />
    </div>
    <div
      v-if="!isPreview"
      class="QRcodeBox"
    >
      <vue-qr
        :text="downloadData.url"
        :margin="0"
        color-dark="#666"
        color-light="#fff"
        :logo-scale="0.3"
        :size="200"
      />
      <span>手机扫码预览</span>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import vueQr from 'vue-qr';
import { removeWatermark, setWaterMark } from '../../../lib/watermark';
import bannerSwipe from './bannerSwipe';
import hometab from './homeTabs';
import lebals from './lebals';
import api from './proxy';
export default {
    name: 'Mobilebox',
    components: {
        hometab,
        bannerSwipe,
        lebals,
    },
    data () {
        return {
            showqq: false,
            showdz: false,
            bannerList: [],
            routerName: null,
            tabList: [],
            catalogList: [],
            siteid: null,
            isPreview: false,
            downloadData: {
                url: '',
                icon: require('../../../assets/image/YXPLOGO.png'),
            },
            shareData: {
                title: 'AI智能伴学', // 分享标题
                desc: '学前启蒙、幼小衔接、小学同步、绘本阅读', // 分享描述
                link: 'https://market.anoah.com/product01/index.html#/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
          'https://daogouapi.youxuepai.com/file/wechat/img/1125144501611YXPLOGO.png', // 分享图标
            },
        };
    },
    created () {
        console.log(this.IsPC());
        if (!this.IsPC()) {
            this.$router.replace({ name: 'mobileContent', query: this.$route.query });
        }
        this.routerName = this.$route.name;
        this.code = this.$route.query.code;
        // window.document.title = this.$store.getters['system/getSiteList'][0].name || '优学派';
        if (this.code) {
            this.isPreview = true;
            this.getSite();
        } else {
            console.log('yl');
            this.siteid = sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId;
            this.getcatalogList();
            this.getrotationInfoList();
            this.getPlug();
            this.getUrl();
            this.websiteMsg = JSON.parse(sessionStorage.getItem('websiteMsg'));
            setTimeout(() => {
                setWaterMark(this.websiteMsg.name, '预览');
            }, 0);
        }
        this.wxshor();
    },
    destroyed () {
        removeWatermark();
    },
    methods: {
        getSite () {
            let params = {
                code: this.code,
            };
            api.getSiteByCode(params).then(res => {
                if (res.errcode === 0) {
                    console.log('getsite', res);
                    if (res.data.webTemplate == 'WEB-002' || res.data.webTemplate == 'WEB-001') {
                        this.$router.replace({
                            path: 'webModulePage',
                            query: {
                                code: this.code,
                            },
                        });
                    } else {
                        this.siteid = String(res.data.id);
                        this.getcatalogList();
                        this.getrotationInfoList();
                        this.getUrl();
                        this.getPlug();
                    }
                }
            });
        },
        topage () {
            this.$router.push({
                name: 'contentManage',
            });
        },
        IsPC () {
            var userAgentInfo = navigator.userAgent;
            var Agents = ['Android', 'iPhone',
                'SymbianOS', 'Windows Phone',
                'iPad', 'iPod'];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        // 获取插件是否显示
        getPlug () {
            const params = {
                siteId: this.siteid,
            };
            api.getPageManagePlugList(params).then((res) => {
                if (res.errcode === 0) {
                    let tableData = res.data.list;

                    this.showqq = tableData[0].useType.includes('0');
                    this.showdz = tableData[1].useType.includes('0');
                    console.log(tableData[1].useType.includes('0'));
                }
            });
        },
        // 获取轮播图
        getrotationInfoList () {
            let params = {
                siteId: this.siteid,
            };
            api.getrotationInfoList(params).then((res) => {
                if (res.errcode === 0) {
                    this.bannerList = res.data.list;
                    console.log(this.bannerList);
                }
            });
        },
        // 获取tab
        getcatalogList (type) {
            let params = {
                siteId: this.siteid,
            };
            api.getcatalogList(params).then((res) => {
                if (res.errcode === 0) {
                    this.tabList = res.data.list;
                    this.catalogDetail(this.tabList[0].catalogId);
                    sessionStorage.setItem('catalogId', this.tabList[0].catalogId);
                }
            });
        },
        // 获取目录
        catalogDetail (id, index) {
            if (index !== undefined && this.tabList[index].type === 1) {
                if (this.routerName === 'mobileModules') {
                    this.$router.push({ name: 'mobileBoxContent', query: { url: this.tabList[index].catalogLink } });
                } else {
                    this.$router.push({ name: 'mobileContent', query: { url: this.tabList[index].catalogLink } });
                }
            } else {
                let params = {
                    siteId: this.siteid,
                    catalogId: id,
                    useScene: this.isPreview ? 1 : 0,
                };
                api.catalogDetail(params).then((res) => {
                    if (res.errcode === 0) {
                        let list = res.data.list;
                        list.forEach(e => {
                            if (e.image !== null) {
                                if (e.image.indexOf(';') !== -1) {
                                    e.image = e.image.slice(0, e.image.indexOf(';'));
                                }
                            }
                        });
                        list.sort(function (a, b) {
                            return a.rank - b.rank;
                        });
                        this.catalogList = list;
                    }
                });
            }
        },
        getUrl () {
            let params = {
                siteId: this.siteid || sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getWebSiteAddress(params).then(res => {
                if (res.errcode === 0) {
                    this.downloadData.url = res.data.value;
                    console.log(this.downloadData.url);
                    // sessionStorage.setItem('downloadData', this.downloadData.url);
                }
            });
        },
        wxshor () {
            let that = this;
            // let url = 'https://market.anoah.com/product01/index.html#/'
            let url = location.href.split('#')[0];
            let params = {
                url: url,
            };
            api.getWxurl(params).then((res) => {
                let data = res.data.data;
                console.log(data);
                // eslint-disable-next-line no-undef
                wx.config({
                    debug: false, // 是否开启调试模式
                    appId: data.appId, // appid
                    timestamp: data.timestamp, // 时间戳
                    nonceStr: data.nonceStr, // 随机字符串
                    signature: data.signature, // 签名
                    jsApiList: [
                        'checkJsApi',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareQZone',
                    ], // 需要使用的JS接口列表
                });

                // eslint-disable-next-line no-undef
                wx.ready(function () {
                    // eslint-disable-next-line no-undef
                    wx.onMenuShareAppMessage({
                        title: that.shareData.title, // 分享标题
                        desc: that.shareData.desc, // 分享描述
                        link: that.shareData.links, // 分享链接
                        imgUrl: that.shareData.imgUrl, // 分享图标
                        success: function () {
                            console.log('分享成功');
                        },
                        cancel: function () {
                            console.log('分享失败');
                        },
                    });
                });
            });
        },
    },
};
</script>
<style lang="scss">
.mobileBox{
  .titleBox{
    .leftIcon{
      cursor: pointer;
      .el-icon-arrow-left{
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang='scss' scoped>
.data {
  display: flex;
  // align-items: center;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  background: #f9f9fa;
  // background:#eee ;
  // margin-top: 10px;
  .mobileBox {
    width: 500px;
    height: 100%;
    border-radius: 5px;
    // border: 1px solid #eee;
    // background-size: 100% 100%;
    //padding: 65px 20px 50px 20px;
    box-shadow: 0px 0px 10px rgba(187,187,187,0.5);
    .titleBox{
      background: #ededed;
      padding: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title{
        flex: 1;
        margin-left: 5px;
        font-size: 8px 0;
        // font-weight: bold;
      }
    }
  }
  .QRcodeBox {
    padding: 10px;
    height: 250px;
    background: white;
    border-radius: 10px;
    // margin-top: 200px;
    // border: 1px solid black;
    display: flex;
    flex-direction: column;
    margin-left: 40px;
    margin-top: 10px;
    span{
      margin-top: 10px;
      text-align: center;
    }
  }
  .post {
    position: absolute;
    right: 45%;
    bottom: 1%;
  }
}

</style>
